
import { Assessment, EventAvailable, FileCopy, Group, PendingActions, TravelExplore as TravelExploreIcon, Settings } from '@mui/icons-material';
import HandshakeIcon from '@mui/icons-material/Handshake';
import InventoryIcon from '@mui/icons-material/Inventory';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ReporteCV from '../../../modulos/reportes/controladorVista/reporteCV';
import { Proyectos } from '../../../modulos/proyectos';
import type { IRuta } from '../../interfaces';
import { Agenda } from '../../../modulos/agenda';
import { Tareas } from '../../../modulos/Tareas';
import { Materiales } from '../../../modulos/materiales';
import { Cotizador } from '../../../modulos/cotizadorNbs';
import { EnumPermisos } from '../../enums/enumPermisos';
import { Usuarios } from '../../../modulos/usuarios';
import GestionArchivos from '../../../modulos/gestionArchivos';
import { listaReportesGenerales } from '../../../mocks/reportes/reportesGenerales';
import { listaReportesCliente } from '../../../mocks/reportes/reportesCliente';
import { Monitor } from '../../../modulos/monitor';
import { ConfiguracionCotizador } from '../../../modulos/configuracionCotizadorNbs';
import { ConfiguracionCotizadorServicios } from '../../../modulos/configuracionCotizadorServicios';
import { CotizadorServicios } from '../../../modulos/cotizadorServicios';
import { ConfiguracionCotizadorPostventa } from '../../../modulos/configuracionCotizadorPostventa';
import { CotizadorPostventa } from '../../../modulos/cotizadorPostventa';

export const rutas: IRuta[] = [
    {
        Ruta: '/Usuarios',
        NombreModulo: 'Usuarios',
        Icono: <Group fontSize={'small'} />,
        Componente: <Usuarios />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_USUARIOS_VER
    },

    {
        Ruta: '/Proyectos',
        NombreModulo: 'Proyectos',
        Icono: <HandshakeIcon fontSize={'small'} />,
        Componente: <Proyectos />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_PROYECTOS_VER
    },
    {
        Ruta: '/Tareas',
        NombreModulo: 'Tareas',
        Icono: <PendingActions fontSize={'small'} />,
        Activa: true,
        Componente: <Tareas />,
        PermisoRequerido: EnumPermisos.PERMISO_TAREAS_VER
    },
    {
        Ruta: '/Agenda',
        NombreModulo: 'Agenda',
        Icono: <EventAvailable fontSize={'small'} />,
        Activa: true,
        Componente: <Agenda />,
        PermisoRequerido: EnumPermisos.PERMISO_VER_AGENDA
    },
    {
        Ruta: '/Materiales',
        NombreModulo: 'Materiales',
        Icono: <InventoryIcon fontSize={'small'} />,
        Activa: true,
        Componente: <Materiales />,
        PermisoRequerido: EnumPermisos.PERMISO_MATERIALES_VER
    },
    {
        Ruta: '/Cotizadores/Configuracion/NBS',
        NombreModulo: 'Configuración Cotizador',
        Icono: <Settings fontSize={'small'} />,
        Componente: <ConfiguracionCotizador />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_COTIZADOR_NBS_CONFIGURAR
    },
    {
        Ruta: '/Cotizadores/Cotizaciones/NBS',
        NombreModulo: 'Cotizaciones',
        Icono: <RequestQuoteIcon fontSize={'small'} />,
        Activa: true,
        Componente: <Cotizador />,
        PermisoRequerido: EnumPermisos.PERMISO_COTIZADOR_NBS_VER
    },
    {
        Ruta: '/Cotizadores/Configuracion/Servicios',
        NombreModulo: 'Configuración Cotizador Servicios',
        Icono: <Settings fontSize={'small'} />,
        Componente: <ConfiguracionCotizadorServicios />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_COTIZADOR_SERVICIOS_CONFIGURAR
    },
    {
        Ruta: '/Cotizadores/Cotizaciones/Servicios',
        NombreModulo: 'Cotizaciones Servicios',
        Icono: <RequestQuoteIcon fontSize={'small'} />,
        Activa: true,
        Componente: <CotizadorServicios />,
        PermisoRequerido: EnumPermisos.PERMISO_COTIZADOR_SERVICIOS_VER
    },
    {
        Ruta: '/Cotizadores/Configuracion/Postventa',
        NombreModulo: 'Configuración Cotizador Postventa',
        Icono: <Settings fontSize={'small'} />,
        Componente: <ConfiguracionCotizadorPostventa />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_COTIZADOR_POSTVENTA_CONFIGURAR
    },
    {
        Ruta: '/Cotizadores/Cotizaciones/Postventa',
        NombreModulo: 'Cotizaciones Postventa',
        Icono: <RequestQuoteIcon fontSize={'small'} />,
        Activa: true,
        Componente: <CotizadorPostventa />,
        PermisoRequerido: EnumPermisos.PERMISO_COTIZADOR_POSTVENTA_VER
    },
    {
        Ruta: '/Cliente/GestionArchivos',
        NombreModulo: 'Gestión Archivos',
        Icono: <FileCopy fontSize={'small'} />,
        Activa: true,
        Componente: <GestionArchivos />,
        PermisoRequerido: EnumPermisos.PERMISO_GESTION_ARCHIVOS_VER
    },
    {
        Ruta: '/Cliente/Reportes',
        NombreModulo: 'Reportes',
        Icono: <Assessment fontSize={'small'} />,
        Componente: <ReporteCV listaReportes={listaReportesCliente} />,
        Activa: false,
        PermisoRequerido: EnumPermisos.PERMISO_REPORTES_CLIENTE_VER
    },
    {
        Ruta: '/Reportes',
        NombreModulo: 'Reportes',
        Icono: <Assessment fontSize={'small'} />,
        Componente: <ReporteCV listaReportes={listaReportesGenerales} />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_REPORTES_GENERALES_VER
    },

    {
        Ruta: '/Monitor',
        NombreModulo: 'Monitor',
        Icono: <TravelExploreIcon fontSize={'small'} />,
        Componente: <Monitor />,
        Activa: true,
        PermisoRequerido: EnumPermisos.PERMISO_MONITOR_VER
    }

];